import { z } from "zod";

import { HistoryDtoSchema } from "../../../dtos/history";

export const GetHistoryPathParamSchema = z.object({
  experienceId: z.string().uuid(),
});

export type GetHistoryPathParamType = z.infer<typeof GetHistoryPathParamSchema>;

export const GetHistoryResponseBodySchema = z.object({
  history: HistoryDtoSchema.array(),
});

export type GetHistoryResponseBodyType = z.infer<
  typeof GetHistoryResponseBodySchema
>;
